import React, { useMemo } from 'react';
import { Redirect } from 'react-router-dom';
import { resolveClientAdminSession } from '../core/auth/resolveClientAdminSession';
import { useTokenManager } from '../contexts/TokenManagerContext';

/**
 * `/emails` legacy path: admins → admin comms; everyone else → dashboard (no artist emails UI here).
 */
const RoleEmailsRouter: React.FC = () => {
  const { getToken } = useTokenManager();
  const routingToken = getToken?.() ?? null;
  const isAdmin = useMemo(
    () => resolveClientAdminSession(routingToken),
    [routingToken]
  );

  if (isAdmin) {
    return <Redirect to="/admin/emails" />;
  }
  return <Redirect to="/dashboard" />;
};

export default RoleEmailsRouter;
